import React, { useState, useEffect } from 'react';
import {
  List,
  Datagrid,
  TextField,
  DateField,
  SearchInput,
  SelectInput,
  useRedirect,
  useUpdate,
  useRefresh,
  ReferenceField,
} from 'react-admin';
import { Route } from 'react-router';

import IconButton from '@material-ui/core/IconButton';
import { Visibility, Check, Close } from '@material-ui/icons';

import { PublicationShow } from './PublicationShow';
import { BooleanField } from './BooleanField';

import LessonListFilter from '../lessons/LessonListFilter';

export const PublicationList = (props) => {
  return (
    <>
      <List {...props} aside={<LessonListFilter showSearch={false} />} filters={publicationFilters} empty={false} bulkActionButtons={false}>
        <Datagrid>
          <TextField source="id" />
          <ReferenceField label="User" source="user_id" reference="users" link="show">
            <TextField source="full_name" />
          </ReferenceField>
          <TextField source="description" label="Descrição" />
          <DateField source="created_at" label="Data de criação" />
          <BooleanField source="is_approved" label="Status" />
          <ActionButton />
          <ActionButton variant="block" />
          <ShowButton />
        </Datagrid>
      </List>
      <Route path="/publications/:id/show">
        {({ match }) =>
          !!match ? (
            <PublicationShow open={!!match} id={match?.params?.id} />
          ) : null
        }
      </Route>
    </>
  );
};

const publicationFilters = [
  <SearchInput source="q" alwaysOn />,
  <SelectInput
    source="is_approved"
    label="Status"
    choices={[
      { id: 'accepted', name: 'Liberados' },
      { id: 'rejected', name: 'Bloqueados' },
    ]}
  />
];

export const ShowButton = ({ basePath, record, onClick }) => {
  const redirect = useRedirect();

  const showPublication = () => {
    if (onClick) {
      onClick(record.id);
    } else {
      redirect('show', basePath, record.id);
    }
  };

  return (
    <IconButton color="primary" onClick={showPublication}>
      <Visibility />
    </IconButton>
  );
}

export const ActionButton = ({resource, record, variant }) => {
  const [ update, { loading } ] = useUpdate();
  const [ clicked, setClicked ] = useState(false);
  const refresh = useRefresh();

  useEffect(() => {
    if (loading || clicked) {
      refresh();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, clicked]);

  const onUpdate = () => {
    setClicked(true);
    const isBlocking = variant === 'block';
    const diff = { is_approved: !isBlocking };
    update(resource, record.id, diff, record);
  }

  return (
    <IconButton color="primary" onClick={onUpdate}>
      {variant === 'block'
        ? <Close />
        : <Check />
      }
    </IconButton>
  );
}